import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from "../../src/utils";

const {
  htmlElement: { FIGURETAG, LINK_SPAN }
} = CkeditorConstants;

/**
 * Handles the toggled state of the button.
 */
export default class PasteCommand extends Command {
  refresh() {
    // Disable the command if the element is in read-only mode.
    // Checked parent element because when target is br tag paste not stopping
    this.listenTo(this.editor.editing.view.document, 'paste', (evt, data) => {
      const editor = this.editor;
      const selection = editor.model.document.selection;
      const selectedBlocks = [...selection.getSelectedBlocks()];    
      if(selectedBlocks.length > 1 &&   !selectedBlocks.some(item => item.name === FIGURETAG || item.name === LINK_SPAN)) {
        evt.stop();
      }
    });
    // Disable the command if the editor is in read-only mode.
    this.isEnabled = !this.editor.isReadOnly;
  }
}
